import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { Spinner } from "@rekonas/ui";

export function ProtectedRoute() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isRestoring) {
    return (
      <main className="grid min-h-screen place-items-center bg-paper text-ink">
        <div className="flex items-center gap-3 text-sm font-medium" role="status">
          <Spinner className="text-teal-600" /> Restoring your secure session…
        </div>
      </main>
    );
  }
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  return <Outlet />;
}
